// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/copy.js';

import { paths } from '../generated/copy';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('copy', Original, paths);
